<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },

  created () {
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      document.onselectstart = new Function('event.returnValue=false')
      // 禁止f12
      document.οnkeydοwn = new Function('event.returnValue=false')
    })

    // 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
    // document.onkeydown = (e) => {
    //   if (e && e.keyCode === 123) {
    //     e.returnValue = false
    //     this.$message.error({message: '请尊重劳动成果！', duration: 5000})
    //     // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
    //     return false
    //   }
    // }
  }
}
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue